import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { WebStorageService } from './web-storage.service';
import { Result, ResultOfT } from '../models/response/result';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService extends BaseService {
  constructor(httpService: HttpClient, webStorageService: WebStorageService) {
    super(httpService,webStorageService);
  }

  getFeatureFlag(featureName: string): Observable<any> {
    return this.get<ResultOfT<Result>>(`FeatureFlag/${featureName}`);
  }
}
